import { IApiBaseProps, IResultResponse } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { apiServerDelete, apiServerPost, apiServerPut } from '@common/axios.services';
import { EProjectDiscussionFormType } from './projectDiscussion.constants';
import {
  ICreateProjectDiscussionRequest,
  IProjectDiscussion,
  IReplyProjectDiscussionRequest,
  ISearchProjectDiscussionRequest,
  IUpdateProjectDiscussionRequest,
} from './projectDiscussion.models';

export const apiRoutes = {
  getProjectDiscussionList: '/ProjectDiscussions/Search',
  createProjectDiscussion: '/ProjectDiscussions',
  updateProjectDiscussionsAsDraft: '/ProjectDiscussions/Draft',
  updateProjectDiscussionsAsIssue: '/ProjectDiscussions/Issue',
  updateProjectDiscussionRepliesAsDraft: '/ProjectDiscussions/Reply/Draft',
  updateProjectDiscussionRepliesAsIssue: '/ProjectDiscussions/Reply/Issue',
  deleteProjectDiscussion: (formType: EProjectDiscussionFormType, id: number) =>
    `/ProjectDiscussions/${formType}/${id}`,
};

export const getProjectDiscussionListAsync = async (
  props: ISearchProjectDiscussionRequest,
): Promise<IPagedResultsV1<IProjectDiscussion>> => {
  const result = await apiServerPost<IPagedResultsV1<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectDiscussionList}`,
    props,
    {
      params: {
        projectId: props.projectId,
      },
    },
  );
  return result.data;
};

export const createProjectDiscussionAsync = async (
  props: ICreateProjectDiscussionRequest,
): Promise<IItemResponse<IProjectDiscussion>> => {
  const result = await apiServerPost<IItemResponse<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.createProjectDiscussion}`,
    props,
    {
      params: {
        projectId: props.projectId,
      },
    },
  );
  return result.data;
};

export const updateProjectDiscussionsAsDraftAsync = async (
  props: IUpdateProjectDiscussionRequest[],
): Promise<IPagedResultsV1<IProjectDiscussion>> => {
  const result = await apiServerPut<IPagedResultsV1<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectDiscussionsAsDraft}`,
    props,
    {
      params: {
        projectId: props[0].projectId,
      },
    },
  );
  return result.data;
};

export const updateProjectDiscussionsAsIssueAsync = async (
  props: IUpdateProjectDiscussionRequest[],
): Promise<IPagedResultsV1<IProjectDiscussion>> => {
  const result = await apiServerPut<IPagedResultsV1<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectDiscussionsAsIssue}`,
    props,
    {
      params: {
        projectId: props[0].projectId,
      },
    },
  );
  return result.data;
};

export const updateProjectDiscussionRepliesAsDraftAsync = async (
  props: IReplyProjectDiscussionRequest[],
): Promise<IPagedResultsV1<IProjectDiscussion>> => {
  const result = await apiServerPut<IPagedResultsV1<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectDiscussionRepliesAsDraft}`,
    props,
    {
      params: {
        projectId: props[0].projectId,
      },
    },
  );
  return result.data;
};

export const updateProjectDiscussionRepliesAsIssueAsync = async (
  props: IReplyProjectDiscussionRequest[],
): Promise<IPagedResultsV1<IProjectDiscussion>> => {
  const result = await apiServerPut<IPagedResultsV1<IProjectDiscussion>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectDiscussionRepliesAsIssue}`,
    props,
    {
      params: {
        projectId: props[0].projectId,
      },
    },
  );
  return result.data;
};

export interface IDeleteProjectDiscussionProps extends IApiBaseProps {
  id: number;
  formType: EProjectDiscussionFormType;
}

export const deleteProjectDiscussionAsync = async (props: IDeleteProjectDiscussionProps): Promise<IResultResponse> => {
  const result = await apiServerDelete<IResultResponse>(
    `${envConfigs.apiBaseUrl}${apiRoutes.deleteProjectDiscussion(props.formType, props.id)}`,
    { params: { projectId: props.projectId } },
  );
  return result.data;
};
